import React from 'react';
import { Box, Typography, Stack, Paper, Link as MuiLink, IconButton } from '@mui/material';
import { Link } from 'react-router';
import { InvoicePaymentFragmentFragment } from '../generated/graphql';
import { useApp } from './app-context';
import { appPaths } from '../app-paths';
import { RemoveItemIcon } from './icons';

interface InvoicePaymentListProps {
  payments: InvoicePaymentFragmentFragment[];
  context: 'invoice' | 'transaction';
  onRemove?: (paymentId: string) => void;
}

export function InvoicePaymentList({ payments, context, onRemove }: InvoicePaymentListProps) {
  const app = useApp();

  // Filter out deleted payments
  const activePayments = payments.filter((a) => !a.deletedAt);

  if (!activePayments || activePayments.length === 0) {
    return (
      <Box>
        <Typography variant="body2" color="text.secondary">
          Žiadne priradené úhrady
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={1}>
      {activePayments.map((payment) => (
        <Paper key={payment.id} variant="outlined" sx={{ p: 1.5 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            {onRemove && (
              <IconButton onClick={() => onRemove(payment.id)} title="Odstrániť priradenie">
                <RemoveItemIcon fontSize="small" />
              </IconButton>
            )}

            <Stack spacing={1} sx={{ flex: 1 }} direction={'row'}>
              <Typography variant="caption" color="text.secondary">
                {app.formatDate(payment.createdAt)}
              </Typography>
              <Typography variant="body2">
                <strong>{app.formatNumber(payment.amount, 2)} €</strong>
              </Typography>
              {context === 'invoice' && payment.transactionId && (
                <MuiLink
                  component={Link}
                  to={appPaths.moneyTransactionList.navigate()}
                  variant="caption"
                  underline="hover"
                >
                  Transakcia (zobraziť zoznam)
                </MuiLink>
              )}
              {context === 'transaction' && payment.invoice && (
                <MuiLink
                  component={Link}
                  to={appPaths.invoice.navigate({ invoiceId: payment.invoiceId })}
                  variant="caption"
                  underline="hover"
                >
                  Faktúra č. {payment.invoice.invoiceNo}
                </MuiLink>
              )}
            </Stack>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
}
